import { SxProps, Theme } from "@mui/material/styles";

export const sxConfig: Record<string, SxProps<Theme>> = {
  wrapper: {
    margin: "-6px -16px"
  },
  heading: {
    width: "100%",
    minWidth: "170px",
    margin: "auto",
    textAlign: "center",
    borderBottom: "1px solid",
    borderBottomColor: "grey.500",
    paddingBottom: "5px"
  },
  headingText: {
    fontSize: "12px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: "grey.900",
    fontWeight: 600
  },
  subtitleWrapper: {
    display: "flex",
    flexDirection: "row",
    paddingTop: "6px",
    marginBottom: "-10px",
    gap: "10px",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "4px"
  },
  subtitle: {
    flexDirection: "row",
    flex: "1 1 100%",
    height: "20px",
    "& svg": {
      height: "30px",
      marginLeft: "-4px",
      marginTop: "-6px"
    },
    justifyContent: "center"
  },
  subtitleText: {
    fontSize: "12px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    fontWeight: 600,
    color: "grey.900"
  }
};
